module.exports = __webpack_public_path__ + "close-399a9cf8233761342b40.svg";